// VALIDATORS
export const PROMO_CODE_PATTERN: RegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).+$/;
export const PROMO_CODE_LENGTH = 12;
export const PROMO_CODE_NAME_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$/!%*#?&+=._-])[A-Za-z\d@$/!%*#?&+=._-]{12}$/;
export const PROMO_CODE_QTY_PATTERN = /[^0-9]/g;
export const PROMO_CODE_DISCOUNT_MAX_VALUE = 99;
export const PROMO_CODE_DISCOUNT_MIN_VALUE = 1;
export const PROMO_CODE_QTY_MAX_VALUE = 100;
export const PROMO_CODE_QTY_MIN_VALUE = 1;

// MESSAGES
export const PROMO_CODE_IS_REQUIRED: string = "payment.promo_code_is_required"
export const PROMO_CODE_INVALID_PATTERN_MESSAGE: string = 'Must include uppercase, lowercase letters, digits, and symbols.'
export const PAYMENT_ERROR_MESSAGE = 'PAYMENT_ERROR_MESSAGE';
export const PROMO_CODE_IS_INVALID_MESSAGE: string = 'payment.promo_code_invalid'
export const PROMO_CODE_IS_EXPIRED_MESSAGE: string = 'payment.promo_code_expired'
export const SUCCESS_PROMO_APPLY_MESSAGE: string = 'Promocode successfully applied.';
export const PRODUCT_SUCCESS_PROMO_APPLY_MESSAGE: string = 'payment.promo_applied';
export const PROMO_LIMIT_EXPIRATION_ERROR_MESSAGE: string = 'payment.promo_limit_reached';
export const PROMO_ALREADY_USED_ERROR_MESSAGE: string = 'payment.promo_already_used';
export const PROMO_CODE_SIZE_ERROR_MESSAGE = 'Must be 12 characters (uppercase, lowercase letters, digits, symbols)';
export const QTY_ERROR_MESSAGE = 'Must be positive integer';
export const QR_QTY_ERROR_MESSAGE = 'Must be only digits';
export const DISCOUNT_ERROR_MESSAGE = 'Must be within 1% to 99%';

// BACK-END RESPONSES
export const PROMO_LIMIT_EXPIRATION_RESPONSE: string = 'Promo Code quantity limit was expired for code';
export const PROMO_EXPIRED_RESPONSE: string = "Expiration date must be in the future.";
export const PROMO_ALREADY_USED_RESPONSE: string = 'Promo code has already been used by the current user';
export const PROMO_CODE_UNIQUE_RESPONSE: string = 'Promo code should be unique';

export const PROMO_CODE_NOT_FOUND: string = 'promoCodeNotFound';
export const PROMO_CODE_EXPIRED: string = 'promoCodeExpired';
export const INVALID_PROMO_CODE: string = 'Invalid promo code';
export const INVALID_PROMO_CODE_MESSAGE: string = 'invalid_promo_code';
export const DELETE_PROMO_CODE_TITLE_ADMIN: string = 'Delete the promo code card?';
export const DELETE_PROMO_CODE_DESCRIPTION: string = 'Remove the viewed card? You will lose all the information entered for this card.';
